import _defineProperty from '@babel/runtime/helpers/defineProperty';
import _extends from '@babel/runtime/helpers/extends';
import _objectWithoutProperties from '@babel/runtime/helpers/objectWithoutProperties';
import EnterpriseIcon, { CheckCircleIcon, ErrorIcon } from '@enterprise-ui/icons';
import classnames from 'classnames';
import React from 'react';
import alertUserOfDeprecatedProps from '../utils/deprecation.js';

var _excluded = ["as", "className"],
  _excluded2 = ["as", "className", "children", "type"],
  _excluded3 = ["as", "className", "children"];
var Timeline = function Timeline(_ref) {
  var _ref$as = _ref.as,
    As = _ref$as === void 0 ? 'ul' : _ref$as,
    className = _ref.className,
    otherProps = _objectWithoutProperties(_ref, _excluded);
  alertUserOfDeprecatedProps('Timeline', otherProps);
  var finalClasses = classnames('C-Timeline --size-normal', className);
  return /*#__PURE__*/React.createElement(As, _extends({
    className: finalClasses
  }, otherProps));
};
Timeline.displayName = 'Timeline';

// ITEM
var TimelineItem = function TimelineItem(_ref2) {
  var _ref2$as = _ref2.as,
    As = _ref2$as === void 0 ? 'li' : _ref2$as,
    className = _ref2.className,
    children = _ref2.children,
    _ref2$type = _ref2.type,
    type = _ref2$type === void 0 ? 'default' : _ref2$type,
    otherProps = _objectWithoutProperties(_ref2, _excluded2);
  alertUserOfDeprecatedProps('TimelineItem', otherProps);
  var finalClasses = classnames('C-Timeline__Item', _defineProperty({}, "--type-".concat(type), type), className);
  return /*#__PURE__*/React.createElement(As, _extends({
    className: finalClasses
  }, otherProps), type === 'success' ? /*#__PURE__*/React.createElement(EnterpriseIcon, {
    className: "C-Timeline__Item__Bullet",
    size: 'sm',
    icon: CheckCircleIcon
  }) : type === 'error' ? /*#__PURE__*/React.createElement(EnterpriseIcon, {
    className: "C-Timeline__Item__Bullet",
    size: 'sm',
    icon: ErrorIcon
  }) : /*#__PURE__*/React.createElement("div", {
    className: "C-Timeline__Item__Bullet"
  }), /*#__PURE__*/React.createElement("div", {
    className: "C-Timeline__Item__Content"
  }, children));
};
Timeline.Item = TimelineItem;
TimelineItem.displayName = 'Timeline.Item';

// FLAG
var TimelineFlag = function TimelineFlag(_ref3) {
  var _ref3$as = _ref3.as,
    As = _ref3$as === void 0 ? 'li' : _ref3$as,
    className = _ref3.className,
    children = _ref3.children,
    otherProps = _objectWithoutProperties(_ref3, _excluded3);
  alertUserOfDeprecatedProps('TimelineFlag', otherProps);
  var finalClasses = classnames('C-Timeline__Flag', className);
  return /*#__PURE__*/React.createElement(As, _extends({
    className: finalClasses
  }, otherProps), /*#__PURE__*/React.createElement("p", null, children));
};
Timeline.Flag = TimelineFlag;
TimelineFlag.displayName = 'Timeline.Flag';

export { TimelineFlag, TimelineItem, Timeline as default };
